
import { useEffect, useState, useCallback } from "react";
import { notificationsAPI } from "../api/notificationsApi";
import { socket } from "../socket";

export const useNotifications = (user) => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const parsedUser = JSON.parse(user || "{}");

  const userId =
    parsedUser?._id || parsedUser?.userId || parsedUser?.id;

  // fetch all
  const fetchNotifications = useCallback(async () => {
    try {
      const { items } = await notificationsAPI.getNotifications();
      setNotifications(items);
    } catch (err) {
      console.error("Fetch notifications error:", err);
    }
  }, []);

  // fetch count
  const fetchUnreadCount = useCallback(async () => {
    try {
      const count = await notificationsAPI.getUnreadCount();
      setUnreadCount(count);
    } catch (err) {
      console.error("Unread count error:", err);
    }
  }, []);

  // 🔥 SOCKET
  useEffect(() => {
    if (!userId) return;

    // ✅ attach latest token before connect
    socket.auth = {
      token: localStorage.getItem("authToken"),
    };

    if (!socket.connected) {
      socket.connect();
    }

    console.log("Socket connecting for user:", userId);

    // 🔥 NEW NOTIFICATION
    socket.on("new_notification", (data) => {
      console.log("Realtime notification:", data);

      setNotifications((prev) => {
        const exists = prev.find(
          (p) => p._id === data.notification._id
        );
        if (exists) return prev;
        return [data.notification, ...prev];
      });

      setUnreadCount((prev) => prev + 1);
    });

    // 🔥 SYNC EVENT — only refresh notification list, NOT the count
    // (fetching count triggers another sync_notifications → infinite loop)
    socket.on("sync_notifications", () => {
      console.log("🔄 Sync triggered");
      fetchNotifications();
    });

    // 🔥 OPTIONAL (if still used)
    socket.on("unread_count", ({ count }) => {
      setUnreadCount(count);
    });

    return () => {
      socket.off("new_notification");
      socket.off("sync_notifications");
      socket.off("unread_count");
    };
  }, [userId, fetchNotifications, fetchUnreadCount]);

  // 🔥 INITIAL LOAD
  useEffect(() => {
    if (!userId) return;

    fetchNotifications();
    fetchUnreadCount();
  }, [userId, fetchNotifications, fetchUnreadCount]);

  return {
    notifications,
    unreadCount,
    refresh: fetchNotifications,
  };
};